
<ng-container *ngIf="type=='carousel'||type=='list';else lazyProduct" >


<ng-container *ngIf="type=='carousel'" >
   <div [ngClass]="{ 'collection-banner': !radius }">
      <div class="img-wrap" #lazyImg [ngStyle.lt-md]="{height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}" [ngStyle.gt-sm]="{height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}">
   <img [alt]="name" [style.border-radius]="radius" [src]="isVisible ? image : null" loading="lazy" decoding="async" (load)="onLoaded()" (error)="onImageError($event, 'assets/images/products/placeholder.jpg')" [style.visibility]="isLoaded ? 'visible' : 'hidden'" />
      <div class="skeleton" *ngIf="showSkeleton"></div>
      </div>
   </div>
</ng-container>

<ng-template  *ngIf="type=='product'">
   <div [ngClass]="{ 'collection-banner': !radius }">
      <div class="img-wrap" #lazyImg [ngStyle.lt-md]="{height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}" [ngStyle.gt-sm]="{height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}">
   <img [alt]="name" [style.border-radius]="radius" [src]="isVisible ? image : null" (load)="onLoaded()" onerror="this.src='assets/images/products/placeholder.jpg';" [style.visibility]="isLoaded ? 'visible' : 'hidden'" />
      <div class="skeleton" *ngIf="showSkeleton"></div>
      </div>
   </div>

</ng-template>

</ng-container>




<ng-template #lazyProduct>
    <div [ngClass]="{ 'collection-banner': !radius }">
       <div class="img-wrap" #lazyImg [ngStyle.lt-md]="{height:height==0?'auto':heightMobile+'px',width:width==0?'auto':widthMobile+'px'}" [ngStyle.gt-sm]="{height:height==0?'auto':height+'px',width:width==0?'auto':width+'px'}">
     <img [alt]="name" [style.border-radius]="radius" [src]="isVisible ? image : image" (load)="onLoaded()" onerror="this.src='assets/images/products/noImage/no-image.png';" [style.visibility]="isLoaded ? 'visible' : 'hidden'" />
        <div class="skeleton" *ngIf="showSkeleton"></div>
       </div>
    </div>
</ng-template>
